// ARCHIVO GENERADO AUTOMATICAMENTE por scripts/generate-env.mjs
// No editar a mano. La fuente real del token es .env.deploy (SENDER_API_TOKEN).
export const secrets = {
  senderApiToken: "Bkcd2yPFtjsYMT1KTLkLe3AGZzD9LMEyeBdyM6dc",
};
